/**
 * Utility functions for handling advertisements
 * Enhanced with better performance and analytics support
 */

/**
 * Removes all Google AdSense ads from the page
 * Used when a user upgrades to Pro during a session
 */
export function removeAllAds() {
  // Remove adsbygoogle ins elements
  document.querySelectorAll('ins.adsbygoogle').forEach((el) => el.remove());

  // Remove ad iframes
  document.querySelectorAll('iframe[src*="googleads"], iframe[src*="doubleclick"]').forEach((el) => el.remove());

  // Clear adsbygoogle array
  if (typeof window !== 'undefined' && window.adsbygoogle) {
    window.adsbygoogle = [];
  }

  // Reset any module-level initialization flags in other files
  if (typeof window !== 'undefined') {
    window.autoAdsInitialized = false;
  }
}

/**
 * Checks if ads should be enabled for the current user
 * @param {boolean} isProMember - Whether the user is a pro member
 * @returns {boolean} - Whether ads should be enabled
 */
export function shouldEnableAds(isProMember) {
  // No ads for pro members
  return !isProMember;
}

/**
 * Calculate ad density for list pages
 * @param {number} numberOfResults - Number of items in the list
 * @returns {number} - How many items between each ad
 */
export const getAdModifier = (numberOfResults) => {
  let adModifier = 0;
  if (numberOfResults > 20) {
    adModifier = 12;
  } else if (numberOfResults > 10) {
    adModifier = 6;
  } else if (numberOfResults > 5) {
    adModifier = 6;
  } else if (numberOfResults > 3) {
    adModifier = 3;
  }
  return adModifier;
};

/**
 * Ad slot configuration mapping
 * Maps logical ad positions to actual AdSense slot IDs
 */
export const AD_SLOTS = {
  // Replace these with your actual AdSense slot IDs
  BELOW_TITLE: '4751464886',
  FIRST_PARAGRAPH: '4871477284',
  MID_CONTENT: '4663593720',
  END_CONTENT: '5607582689',
  SIDEBAR: '2245313949',
  IN_FEED: '2701669002',
  STICKY_MOBILE: '8431448345',
};

/**
 * Get minimum height for ad type to prevent CLS
 * @param {string} adType - Type of ad
 * @returns {number} - Minimum height in pixels
 */
export const getMinHeightForAdType = (adType) => {
  const heights = {
    display: 90,
    'in-article': 120,
    multiplex: 200,
    sidebar: 250,
    mobile: 50,
  };

  return heights[adType] || 90;
};

/**
 * Check if the current page should show ads
 * @param {string} pathname - Current page path
 * @returns {boolean} - Whether ads should be shown on this page
 */
export const shouldShowAdsOnPage = (pathname) => {
  // Pages where ads might be disabled
  const noAdPages = ['/checkout', '/payment', '/pro-membership', '/account'];

  return !noAdPages.some((page) => pathname?.startsWith(page));
};
